export default () => ({
  scheduled: [],
  showModal: false,
  schedules: [],
  currentItem: {},
  currentTime: null,
  currentCovenant: null,
  currentPatient: null

})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/schedule/resources/data.js